/* eslint-disable react/jsx-key */
import LoadBalancer from 'react-scale/components/GrowthCenter/OnboardingControlPanel/components/LoadBalancer';
import {
  ContributorFacingNameInput,
  TerminusDestinationInput,
  CourseIdInput,
  StepTypeSelector,
  SourceNodeSelector,
  DestNodeSelector,
  ConditionsConfigurator,
  BypassWhitelistConfigurator,
  ConnectedNodes,
  ContributorFacingDescriptionInput,
  FinalizeConditionInput,
  ResumeScreeningConfigIdInput,
  SelectCommunityInput,
} from '../components/ConfigComponents';
import SignupFlowConfigInput from '../components/signupFlow/SignupFlowConfigInput';
import { OnboardingStepType, OnboardingFlowNodeType } from '@scale/shared/onboardingControlPanel';
import GrantsConfigurator from 'react-scale/components/GrowthCenter/OnboardingControlPanel/components/GrantsConfigurator';
import InterviewConfigAutocomplete from 'react-scale/components/GrowthCenter/OnboardingControlPanel/components/InterviewConfigAutocomplete';
import SkillScreeningConfigAutocomplete from 'react-scale/components/GrowthCenter/OnboardingControlPanel/components/SkillScreeningConfigAutocomplete';

export enum FlowEntityType {
  Transition = 'Transition',
}

const FlowEntityConfig: Partial<
  Record<OnboardingStepType | OnboardingFlowNodeType | FlowEntityType, React.ReactNode[]>
> = {
  [OnboardingFlowNodeType.Terminus]: [
    <StepTypeSelector required />,
    <TerminusDestinationInput required />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.Signup]: [<SignupFlowConfigInput />, <ConnectedNodes />],
  [OnboardingStepType.Dummy]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.PhoneVerification]: [<ConnectedNodes />],
  [OnboardingStepType.LinkedInConnection]: [<ConnectedNodes />],
  [OnboardingStepType.Persona]: [<ConnectedNodes />],
  [OnboardingStepType.SkillSelection]: [<ConnectedNodes />],
  [OnboardingStepType.UnifiedSkillsScreenings]: [<ConnectedNodes />],
  [OnboardingStepType.JoinSlack]: [<ConnectedNodes />],
  [OnboardingStepType.Course]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <CourseIdInput required stepType={OnboardingStepType.Course} />,
    <BypassWhitelistConfigurator />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.AwaitCourseOutcome]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <CourseIdInput required stepType={OnboardingStepType.AwaitCourseOutcome} />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.PlatformCourse]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <CourseIdInput required stepType={OnboardingStepType.PlatformCourse} />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.ScheduleInterview]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <InterviewConfigAutocomplete required stepType={OnboardingStepType.ScheduleInterview} />,
    // TODO enable when debugged
    <FinalizeConditionInput required />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.AsyncInterview]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <InterviewConfigAutocomplete required stepType={OnboardingStepType.AsyncInterview} />,
    // TODO enable when debugged
    <FinalizeConditionInput required />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.SkillScreening]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <SkillScreeningConfigAutocomplete required stepType={OnboardingStepType.SkillScreening} />,
    <BypassWhitelistConfigurator restrictToTestAccounts={true} />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.InterviewOutcome]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <InterviewConfigAutocomplete required stepType={OnboardingStepType.InterviewOutcome} />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.Benchmark]: [<StepTypeSelector required />],
  [OnboardingStepType.ResumeCollection]: [<ConnectedNodes />],
  [OnboardingStepType.ResumeScreen]: [
    <StepTypeSelector required />,
    <ContributorFacingNameInput />,
    <ContributorFacingDescriptionInput />,
    <ResumeScreeningConfigIdInput required stepType={OnboardingStepType.ResumeScreen} />,
    <ConnectedNodes />,
  ],
  [OnboardingStepType.LoadBalancer]: [
    <StepTypeSelector required />,
    <ConnectedNodes />,
    <LoadBalancer />,
  ],
  [FlowEntityType.Transition]: [
    <SourceNodeSelector required />,
    <DestNodeSelector required />,
    <ConditionsConfigurator required />,
    <GrantsConfigurator />,
  ],
  [OnboardingStepType.JoinCommunity]: [
    <SelectCommunityInput />,
    <BypassWhitelistConfigurator forceEditable={true} />,
    <ConnectedNodes />,
  ],
};

export default FlowEntityConfig;
